// extracted by mini-css-extract-plugin
module.exports = {"container":"text_container__Ho0oI","container1":"text_container1__jC-zr","Heading":"text_Heading__1pjdA"};